export const SIMULATION_INFO_REDESIGN_PATH = /\/awareness-center\/report\/[^/]+\/html\/redesign\/?$/

export const isSimulationReportRedesignPath = (
  pathname = typeof window === 'undefined' ? '' : window.location.pathname
) => SIMULATION_INFO_REDESIGN_PATH.test(pathname)

const TEMPLATES = [
  {
    id: 't-invoice',
    name: 'Invoice approval',
    senderName: 'Acme Invoices',
    sender: 'billing@acme-invoices.co',
    domain: 'acme-invoices.co',
    domainCategory: 'Look-alike vendor',
    subject: 'Invoice #INV-4471 needs your approval',
    category: 'Finance / Vendor',
    level: 'Expert level',
    fileStem: 'Invoice-INV-4471',
    body: {
      paragraph:
        'Invoice #INV-4471 from Acme Invoices is awaiting your approval. It was due on 8 Aug and will be escalated to Finance if it is not approved by end of day.',
      link: 'Please review and approve the invoice below.',
      attachment: 'The invoice is attached to this email - please review and approve it today.',
      cta: 'Review invoice',
      signature: 'Acme Invoices · Accounts Receivable',
    },
  },
  {
    id: 't-contract',
    name: 'Contract for signature',
    senderName: 'e-Sign Services',
    sender: 'notify@esign-services.net',
    domain: 'esign-services.net',
    domainCategory: 'Look-alike service',
    subject: 'Contract #C-2291 is ready for your signature',
    category: 'Legal / Documents',
    level: 'Mid level',
    fileStem: 'Contract-C-2291',
    body: {
      paragraph:
        'A contract from Legal is waiting for your e-signature. Unsigned documents expire after 48 hours and have to be re-issued.',
      link: 'Please review and sign the document below.',
      attachment: 'The contract is attached to this email - please review and sign it today.',
      cta: 'Review and sign',
      signature: 'e-Sign Services · Document delivery',
    },
  },
  {
    id: 't-payroll',
    name: 'Payroll details',
    senderName: 'People Portal',
    sender: 'hr-notices@people-portal.co',
    domain: 'people-portal.co',
    domainCategory: 'Look-alike HR portal',
    subject: 'Action required: confirm your payroll details',
    category: 'HR / Payroll',
    level: 'Beginner level',
    fileStem: 'Payroll-confirmation',
    body: {
      paragraph:
        'Payroll closes on Friday. The bank details on file could not be verified and need to be confirmed before the run.',
      link: 'Please confirm your details below.',
      attachment:
        'The form is attached to this email - please complete and return it before Friday.',
      cta: 'Confirm details',
      signature: 'People Portal · Payroll team',
    },
  },
]

const MODULES = [
  { id: 'm-invoice', title: 'Spotting Invoice Fraud', vendor: 'Wizer', length: '4 min' },
  {
    id: 'm-credentials',
    title: 'Spotting credential harvesting',
    vendor: 'IRONSCALES',
    length: '6 min',
  },
]

export const simulationCampaignInfoFixture = (campaignId) => ({
  id: Number(campaignId) || 28,
  name: 'Q3 Invoice Update Simulation',
  available: true,
  state: 'active',
  phase: 'collecting',
  vector: 'dataEntry',
  fileFormat: null,
  deliveryDate: '2026-08-10',
  deliveryTime: '09:00',
  emailsPerDay: 48,
  collectingUntil: '2026-08-24',
  timezone: 'Europe/Dublin',
  launchedBy: 'Natali Talmor',
  reminders: { everyXDays: 3, total: 4 },
  sendWindow: {
    days: 5,
    perDay: 48,
    start: '2026-08-10',
    end: '2026-08-14',
  },
  settings: {
    businessDaysOnly: true,
    randomized: true,
    failureEmail: false,
    sendSummaryToRecipientList: true,
  },
  templates: TEMPLATES,
  landingPage: {
    title: 'Microsoft 365 sign-in (cloned)',
    createdBy: 'IRONSCALES library',
    url: '/campaign/landings/preview/91/1',
  },
  modules: MODULES,
})
